import { observable, configure, action, computed } from 'mobx';
import LocalModel from './localModel';

configure({ enforceActions: 'always' });

// The organiser club of a race, as the race admin's Vipps setup page sees it.
// Backed by /api/raceorganisers/:raceId — the object's id IS the race id, so
// FormFieldsCompact's saveField() PATCHes straight back through the race-scoped
// route (race admins are not members of the club customer itself).
class RaceOrganiserStore extends LocalModel {
    constructor() {
        super('raceOrganiser', {
            namePlural: 'raceOrganisers',
            namePluralReal: 'raceorganisers',
            sort: 'id',
            limit: 1,
            api: {
                search: {
                    url: '/api/raceorganisers/',
                    params: {},
                },
                load: {
                    url: '/api/raceorganisers/',
                    params: {},
                },
                save: {
                    url: '/api/raceorganisers/',
                    params: {},
                },
                delete: {
                    url: '/api/raceorganisers/',
                    params: {},
                },
            },
        });
    }

    @observable raceOrganiser = {};

    @observable raceOrganisers = [];

    // Filled from `included` by load(id, false, { addData: ['race', 'termsUrl'] }).
    @observable race = {};

    @observable termsUrl = '';

    @computed get organiserRaceId() {
        return this.raceOrganiser?.id || 0;
    }

    @action
    reset() {
        this.raceOrganiser = {};
        this.race = {};
        this.termsUrl = '';
    }
}

const store = new RaceOrganiserStore();
export default store;
